'use client'
import React from 'react'

export const Separator: React.FC = () => <span className="paginator__separator">&mdash;</span>
